import React from "react";
import { Attachment } from "@mui/icons-material";
import { ListItemIcon, MenuItem } from "@mui/material";

import AttachmentModal from "fond/attachments/AttachmentModal";
import { PermissionLevel } from "fond/types";
import { Actions, permissionCheck } from "fond/utils/permissions";

interface IProps {
  permissionLevel: PermissionLevel;
  handleClose: () => void;
}

const Files: React.FC<IProps> = ({ permissionLevel, handleClose }: IProps) => {
  const [isAttachmentModalOpen, setAttachmentModalOpen] = React.useState<boolean>(false);
  const canViewAttachments = permissionCheck(permissionLevel, Actions.PROJECT_VIEW_ATTACHMENT);

  /**
   * Handles opening the Project Attachments modal
   */
  const handleAttachments = () => {
    if (canViewAttachments) {
      setAttachmentModalOpen(true);
    }
    handleClose();
  };

  const onModalClose = () => {
    setAttachmentModalOpen(false);
  };

  return (
    <>
      <MenuItem data-testid="files-button" onClick={handleAttachments} disabled={!canViewAttachments}>
        <ListItemIcon>
          <Attachment />
        </ListItemIcon>
        Files
      </MenuItem>
      {isAttachmentModalOpen && <AttachmentModal onClose={onModalClose} isOpen />}
    </>
  );
};

export default Files;
